try {
    window.$ = window.jQuery = require('jquery');

    //media query breakpoints
    require('@bit/apollo-web-services.pattern-library.media-query-breakpoints/mq_breakpoints.js');

    //bootstrap
    require('bootstrap/dist/js/npm.js');

    //kendo-ui
    require('@progress/kendo-ui/js/kendo.autocomplete.js');
    require('@progress/kendo-ui/js/kendo.dropdownlist.js');
    require('@progress/kendo-ui/js/kendo.multiselect.js');
    require('@progress/kendo-ui/js/kendo.grid.js');
    require('@progress/kendo-ui/js/kendo.listview.js');
    require('@progress/kendo-ui/js/kendo.pager.js');
    require('@progress/kendo-ui/js/kendo.router.js');

    //responsive hero
    window.responsiveHero = require('@bit/apollo-web-services.pattern-library.hero-responsive/hero-responsive.js');

    //anchor smooth scroll
    require('@bit/apollo-web-services.pattern-library.anchor-smooth-scroll/anchor-smooth-scroll.js');

    //custom form select formatting
    require('@bit/apollo-web-services.pattern-library.forms/forms.js');

    //simple lightbox
    require('simple-lightbox/src/simpleLightbox.js');

    //navbar slide menu
    require('@bit/apollo-web-services.pattern-library.navbar/navbar-slide-collapse.js');

    //modal directional slide
    require('@bit/apollo-web-services.pattern-library.modals/modals.directional.js');

    //google analytics event tracking
    require('@bit/apollo-web-services.pattern-library.ga-event-tracking/ga-event-tracking.js');

    //replace  images source .svg with inline SVG
    require('@bit/apollo-web-services.pattern-library.image-to-svg/img2svg.js');
} catch (e) {}
